import { createSelector } from "@reduxjs/toolkit";

const currenciesDataSelector = createSelector(
  (state) => state.currenciesData,
  (a) => a
);

export default currenciesDataSelector;
